import { render, staticRenderFns } from "./AssetForm.vue?vue&type=template&id=a79640ae&scoped=true&"
import script from "./AssetForm.vue?vue&type=script&lang=js&"
export * from "./AssetForm.vue?vue&type=script&lang=js&"
import style0 from "./AssetForm.vue?vue&type=style&index=0&id=a79640ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79640ae",
  null
  
)

export default component.exports